import React              from 'react';
import SelectableEggBox   from '../../components/SelectableEggBox';
import UnSelectableEggBox from '../../components/UnSelectableEggBox';
import { makeStyles }     from '@material-ui/core/styles';

var clsx = require('classnames')


const useStyles = makeStyles(theme => ({
    target: {
        zIndex:         1,
        display:        'flex',
        flexFlow:       'column',
        alignItems:     'center',
        justifyContent: 'center',
        borderRadius:   '1em',
    },
    inner: {
        backgroundPosition: 'center',
        backgroundRepeat:   'no-repeat',
        backgroundSize:     'contain',
    },
    shake: {
      animation:               'shake 0.5s',
      animationIterationCount: '0.5s',
  },
    dont_shake: {
  }
}));

type TargetProps = {    
    disabledEggsArr:    number[];
    index:              number;
    target_size:        number;
    value:              number;
    draggedEgg:         number;
    initialValue:       number;
    showFinalValue:     boolean;
    putEggBackInBox:    boolean;
    disable:            boolean;
    wideScreen:         boolean;
    selectable:         boolean;
    eraseImages:        boolean;
    closeAtTen:         boolean;
    dragOrSelect:       string;
    handleEggSelection: (ind: number, counter: number, val: number) => void;
    handleMouseDown:    (e: React.MouseEvent, ind: number) => void;
    handleTouchStart:   (e: React.TouchEvent, ind: number) => void;
}

const Target: React.FC<TargetProps> = ({ 
  disabledEggsArr,
  index,
  target_size, 
  initialValue,
  disable,
  value,
  draggedEgg,
  showFinalValue,
  putEggBackInBox,
  wideScreen,
  dragOrSelect,
  selectable,
  eraseImages,
  closeAtTen,
  handleEggSelection,
  handleMouseDown,
  handleTouchStart
}) => {

  const classes = useStyles();

  const [shake, setShake]           = React.useState(false)
  /* const [closeAtTen, setCloseAtTen] = React.useState(false)

  React.useEffect(() => {
     if (stage1complete) {
        setCloseAtTen(true)
     }
     else {
      setCloseAtTen(false)
     }
  },[stage1complete]) */


  const selectableBox = React.useMemo(() => {
    return selectable && value < 10
  },[selectable, value])

  const handleRejection = () => {
    setShake(true)
    setTimeout(() => {
       setShake(false)
    },500)
  }

  return (
    <div 
      className = { clsx(classes.target, (shake ? classes.shake : classes.dont_shake)) }
      onClick   = { () => { if (!selectable) { handleRejection() }}}
      style = {{ 
        width:  target_size - 2,
        height: (target_size/2) - 2,
      }}
    >
      {
        !eraseImages && selectableBox
        &&
        <SelectableEggBox
           index            = { index }
           wideScreen       = { wideScreen }
           value            = { showFinalValue ? value : initialValue }
           putEggBackInBox  = { putEggBackInBox }
           showFinalValue   = { showFinalValue }
           draggedEgg       = { draggedEgg }
           disable          = { disable }
           disabledEggsArr  = { disabledEggsArr }
           drag             = { dragOrSelect === 'drag' }
           handleClick      = { handleEggSelection }
           handleRejection  = { handleRejection }
           handleMouseDown  = { handleMouseDown }
           handleTouchStart = { handleTouchStart }
        />
      } 
      {
        !eraseImages && !selectableBox
        &&
        <UnSelectableEggBox
           wideScreen = { wideScreen }
           value      = { value }
           closeAtTen = { closeAtTen }
        />
      }  
    </div>
  )
}
export default Target
